export default (client) => {
  return {
    fetchAll(workspaceId) {
      return client.get(`/workspaces/${workspaceId}/menu-entries/`)
    },
    create(workspaceId, values) {
      return client.post(`/workspaces/${workspaceId}/menu-entries/`, values)
    },
    update(workspaceId, menuEntryId, values) {
      return client.patch(
        `/workspaces/${workspaceId}/menu-entries/${menuEntryId}/`,
        values
      )
    },
    delete(workspaceId, menuEntryId) {
      return client.delete(`/workspaces/${workspaceId}/menu-entries/${menuEntryId}/`)
    },
  }
}
